import { Box, IconButton, Typography } from '@mui/material';

import { DeleteIcon } from '../../components/shared/CustomIcons';

import { IMedication } from './types';

interface IMedicationItemProps {
  medication: IMedication;
  onPreviewOpen: (medication: IMedication) => void;
  onDeleteOpen: (medicationId: number) => void;
}

const MedicationItem: React.FC<IMedicationItemProps> = ({
  medication,
  onPreviewOpen,
  onDeleteOpen,
}) => (
  <Box
    key={medication.id}
    sx={{
      minHeight: 128,
      bgcolor: 'common.white',
      px: 3.25,
      py: 2.5,
      justifyContent: 'space-between',
    }}
    className="d-flex flex-row align-items-center rounded-50"
    onClick={() => onPreviewOpen(medication)}
  >
    <Box className="d-flex flex-column justify-content-center">
      <Typography variant="h6" sx={{ mb: 1.25 }}>
        {medication.name}
      </Typography>
      <Typography variant="body1" sx={{ color: 'text.secondary' }}>
        {medication.frequency} {`- ${medication.dosage}`}
      </Typography>
    </Box>

    <IconButton
      onClick={(e) => {
        e.stopPropagation();
        onDeleteOpen(medication.id);
      }}
    >
      <DeleteIcon sx={{ width: 24, height: 24, color: 'error.main' }} />
    </IconButton>
  </Box>
);

export default MedicationItem;
